import script from "./WarningCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./WarningCard.vue?vue&type=script&setup=true&lang=ts"

import "./WarningCard.vue?vue&type=style&index=0&id=562169ce&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-562169ce"]])

export default __exports__